<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
import { commonKey } from "@/common/config/constant";
import crypto from "@/common/utils/crypto.js";
export default {
  globalData: {
    host: "http://mac.txlt.com",
    is_gzh: 0,
    is_wx_mini: false,
    site: "",
    webInfo: {},
    cates: [],
    socketOpen: false, //websocket是否开启
    hasResume: false, //是否有简历
    user: "",
    shareConfig: {},
    siteInfo: {},
  },
  onError() {
    // #ifdef MP-WEIXIN
    this.handleError();
    //#endif
  },
  onLaunch: async function () {
    // #ifdef MP-WEIXIN
    this.handleError();
    //#endif
    //#ifndef H5
    // uni.setStorageSync('site',{"id":33,"name":"象山招聘","region_id":121,"host":"xiangshan.datingmao.com","region_name":"象山"})
    //#endif

    //#ifdef H5

    let url = window.location.href;
    let token = this.helper.getParam(url, "token");
    if (token) {
      uni.setStorageSync("token", token);
    }
    //#endif

    //#ifdef H5
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.globalData.is_gzh = 1;
    }
    //#endif

    await this.setSite();
    await this.getCates();

    let authRes = await this.$u.api.checkToken();

    if (authRes.code == 0) {
      uni.setStorageSync("token", "");
      uni.setStorageSync("user", "");
    } else {
      uni.setStorageSync("user", authRes.data.user);
    }

    // #ifdef MP-WEIXIN
    this.globalData.is_wx_mini = true;

    // #endif
    try {
      await this.$isResolve();
    } catch (e) {}
    this.refreshNoRead();
    this.refreshTimeNotice();

    setTimeout(async () => {
      await this.helper.handleRegionApi();
    }, 5000);
    // await this.$chat.dispatch('websocketInit', this.$websocketHost)
  },
  methods: {
    handleReplace(type) {
      let info = this.shareConfig["default"];
      if (type === 1) {
        return info.share_desc.replace("${site_name}", this.siteInfo.name);
      }

      const title = info.share_title.replace(
        "${site_name}",
        this.siteInfo.name
      );
      return title;
    },
    handleError() {
      new Promise((resovle, reject) => {
        const updateManager = uni.getUpdateManager();

        updateManager.onCheckForUpdate(function (res) {
          console.log(res.hasUpdate);
        });

        updateManager.onUpdateReady(function (res) {
          uni.showModal({
            title: "更新提示",
            content: "新版本已经准备好，是否重启应用？",
            success(res) {
              if (res.confirm) {
                updateManager.applyUpdate();
              }
            },
          });
        });
      });
    },
    async setSite() {
      let res = await this.$u.api.hostCity({});
      if (!res.code) {
        this.showMsg(res.msg);
      }
      let site = res.data.site;
      this.$store.commit("setSiteInfo", site);
      uni.setStorageSync("site", res.data.site);
      uni.setStorageSync("siteShow", false);

      const newRes = await this.$u.api.shareConfig({});
      this.$store.commit("setShareConfig", newRes.data);
      this.siteInfo = site;
      this.shareConfig = newRes.data;

      let webRes = await this.$u.api.webInfo({});
      //#ifdef H5
      if (webRes.data.h5_statistics) {
        this.inserStatistics(webRes.data.h5_statistics || "");
      }
      //#endif
      uni.setStorageSync("webInfo", webRes.data);
      this.globalData.site = site;
      this.globalData.webInfo = webRes.data;
      this.init_weixin();
    },

    // 动态添加 百度站点 统计
    inserStatistics(statisticsCode) {
      if (!statisticsCode) {
        return;
      }
      const matchedLinks = statisticsCode.match(
        /https:\/\/hm.baidu.com\/hm.js\?[0-9a-zA-Z]+/
      );
      if (!matchedLinks.length) {
        return;
      }
      const hm = document.createElement("script");
      hm.src = matchedLinks[0];
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    },

    async getCates() {
      let res = await this.$u.api.cate();
      uni.setStorageSync("cate", res.data);
      this.globalData.cates = res.data;
      this.$store.commit("setCates", res.data);
    },

    /** 获取用户地址 */
    // getLocation() {
    //   const _this = this;
    //   // #ifdef MP-WEIXIN
    //   uni.getSetting({
    //     success: (res) => {
    //       console.log("res", res);
    //       if (res.authSetting["scope.userLocation"]) {
    //         uni.getLocation({
    //           success: async (res) => {
    //             console.log("res", res);
    //             await _this.$stores.commit("user/SET_LOCATION", res);
    //           },
    //           fail(err) {
    //             console.log(err);
    //           },
    //         });
    //       } else {
    //         uni.authorize({
    //           scope: "scope.userLocation",
    //           success() {
    //             uni.getLocation({
    //               success: async (res) => {
    //                 console.log("res", res);
    //                 await _this.$stores.commit("user/SET_LOCATION", res);
    //               },
    //               fail(err) {
    //                 console.log(err);
    //               },
    //             });
    //           },
    //         });
    //       }
    //     },
    //   });
    //   // #endif

    //   // #ifdef H5
    //   // jWeixin
    //   jWeixin.getLocation({
    //     success: async (res) => {
    //       console.log("res", res);
    //       await _this.$stores.commit("user/SET_LOCATION", res);
    //     },
    //     fail(err) {
    //       console.log(err);
    //     },
    //   });
    //   // #endif
    // },
    miniLogin() {
      let that = this;
      uni.login({
        success: function (loginRes) {
          let code = loginRes.code;
          that.$u.api.miniLogin({ code: code }).then((res) => {
            if (res.code == 1) {
              uni.setStorageSync("user", res.data);
              uni.setStorageSync("token", res.data.access_token);
              // uni.setStorageSync("token",res.data.token)
            } else {
              uni.setStorageSync("third_key", res.data.third_key);
            }
          });
        },
      });
    },
    navTitle() {
      if (this.globalData.is_gzh == 1) {
        let navTitles = document.getElementsByTagName("uni-page-head");
        let navWait = setInterval(() => {
          if (navTitles.length > 0) {
            navTitles[0].style.display = "none";
            clearInterval(navWait);
          } else {
            navTitles = document.getElementsByTagName("uni-page-head");
          }
        }, 100);
      }
    },
    async init_weixin() {
      //#ifdef H5
      if (this.globalData.is_gzh == 1) {
        // 在微信浏览器
        let res = await this.$u.api.wxconfig({});
        let webInfo = res.data.web_info;

        res.data.js_config.debug = false;
        res.data.js_config.jsApiList.push("openLocation");
        res.data.js_config.jsApiList.push("getLocation");
        // let webInfo = uni.getStorageInfoSync('webInfo')
        const title = this.handleReplace(2);
        const desc = this.handleReplace(1);

        let link = this.helper.GetUrlRelativePath();
        // uni.setStorageSync("webInfo", res.data)
        jWeixin.config(res.data.js_config);
        jWeixin.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          jWeixin.updateAppMessageShareData({
            title: title, // 分享标题
            link: link,
            desc: desc, // 分享描述
            imgUrl: webInfo.logo_url, // 分享图标
            success: function () {
              // 设置成功
            },
          });

          jWeixin.updateTimelineShareData({
            title: title, // 分享标题
            link: link,
            desc: desc, // 分享描述
            imgUrl: webInfo.logo_url, // 分享图标
            success: function () {
              // 设置成功
            },
          });

          jWeixin.onMenuShareTimeline({
            title: title, // 分享标题
            link: link,
            desc: desc, // 分享描述
            imgUrl: webInfo.logo_url, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
            },
          });

          jWeixin.onMenuShareAppMessage({
            title: title, // 分享标题
            link: link,
            desc: desc, // 分享描述
            imgUrl: webInfo.logo_url, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
            },
          });
        });
      }
      //#endif
      // this.getLocation();
    },

    refreshNoRead() {
      let _this = this;
      setInterval(() => {
        if (uni.getStorageSync("token")) {
          this.$u.api.chatNoReadNum().then((res) => {
            if (res.code) {
              _this.$chat.dispatch("changeNoReadNum", res.data.no_read_num);
            }
          });
        }
      }, 5000);
    },

    refreshTimeNotice() {
      let _this = this;
      setInterval(() => {
        if (uni.getStorageSync("token")) {
          if (uni.getStorageSync("user").role_id === 1) {
            this.$u.api.recruitTimeNotice().then((res) => {
              if (res.code) {
                _this.$chat.dispatch("refreshNotice", res.data);
              }
            });
          }
        }
      }, 5000);
    },
  },
  onShow: async function () {
    this.$beforOnShow();

    await this.$onLaunched;
    this.init_weixin();
  },
  onHide: function () {
    // console.log('App Hide')
  },
};
</script>

<style lang="scss">
@import "uview-ui/index.scss";
@import "static/css/style.scss";
/*每个页面公共css */
uni-modal {
  z-index: 999999 !important;
}

uni-page-head .uni-page-head__title {
  font-size: 35rpx !important;
}

.u-badge {
  min-width: 16px;
  min-height: 16px;
}

.u-search {
  .u-content {
    background: $u-style-bg !important;

    .u-input {
      background: $u-style-bg !important;
    }
  }
}

.u-content__showmore-wrap {
  display: flex;
  justify-content: flex-start !important;
}

.uni-input-placeholder {
  color: rgba(173, 173, 173, 1) !important;
  font-size: 28rpx !important;
}

.u-select__header {
  .u-select__header__btn {
    font-size: 32rpx !important;
  }
}
</style>